// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
 
i18n
  .use(initReactI18next)
  .init({
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language if translation is missing
    interpolation: {
      escapeValue: false, // not needed for React
    },
  });
 
export default i18n;